import React from 'react';
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Footprint,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {rose} from '/theme/color/secondary.color';

import NavigationHeader from '../NavigationHeader';

const storyStyle = StyleSheet.create({
  footprint: {
    width: '100%',
  },
  content: {
    width: '100%',
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: rose,
  },
});

storiesOf('layout', module).add('NavigationHeader', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView expand={true}>
        <Heading level={1}>Navigation Header</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>NavigationHeader</Code> component is used to render a
          navigation header with icons.
        </Text>
        <Spacer size={16} />
        <Text>
          The space above the icons is reserved for the device's status bar. The
          actual amount of whitespace will be different between different device
          screen geometries.
        </Text>
        <Spacer size={16} />
        <Footprint style={storyStyle.footprint}>
          <NavigationHeader rightIcons={['search']} />
        </Footprint>
        <Spacer size={16} />
        <Heading level={2}>Content Wrapper</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>NavigationHeader</Code> wrapper component is a wrapper
          component around some contents.
        </Text>
        <Spacer size={16} />
        <Footprint style={storyStyle.footprint}>
          <NavigationHeader rightIcons={['search']}>
            <View style={storyStyle.content}>
              <Text>Content</Text>
            </View>
          </NavigationHeader>
        </Footprint>
        <Spacer size={6} />
        <Code>{'<NavigationHeader>'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'</NavigationHeader>'}</Code>
        <Spacer size={16} />
        <Heading level={2}>Event Handler</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>NavigationHeader</Code> component accepts a{' '}
          <Code>onIconPress</Code> prop to be used as event handler when an icon
          is clicked.
        </Text>
        <Spacer size={6} />
        <Code>{'<NavigationHeader'}</Code>
        <Code>{'  onIconPress={(iconName) => {...}}>'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'</NavigationHeader>'}</Code>
        <Spacer size={16} />
        <Heading level={2}>Back Button</Heading>
        <Spacer size={16} />
        <Text>
          By default the <Code>NavigationHeader</Code> component will render a
          back icon if the current navigation state has somewhere to go back to.
        </Text>
        <Spacer size={16} />
        <Text>
          To not render this icon automatically, pass in the{' '}
          <Code>{'autoShowBack={false}'}</Code> prop.
        </Text>
        <Spacer size={6} />
        <Code>{'<NavigationHeader autoShowBack={false}>'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'</NavigationHeader>'}</Code>
        <Spacer size={6} />
        <Footprint style={storyStyle.footprint}>
          <NavigationHeader autoShowBack={false} rightIcons={['search']}>
            <View style={storyStyle.content}>
              <Text>Content</Text>
            </View>
          </NavigationHeader>
        </Footprint>
      </FlexView>
    </Spacing>
  </ScrollView>
));
